"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(content) {
  var html = (0, _isString2["default"])(content) ? content : content.content;

  // Replace variables
  if (content.meta && content.meta.variables) {
    (0, _forEach2["default"])(content.meta.variables, function (value, variable) {
      if (typeof value === 'number') {
        value = value.toString();
      }
      if (!value) {
        return;
      }
      var regex = new RegExp("<span[^>]*data-variable=\"".concat(variable, "\"[^>]*>[^>]*</span>"), 'ig');
      html = html.replace(regex, value);
    });
  }
  return html;
};